import { Link } from "react-router-dom";

const localSpecialties = [
  {
    name: "Arthoscopy",
    image: "/images/specialties/Arthroscopy & Sports Injury Treatment.webp",
    alt: "Arthoscopy",
    icon: "arthoscopy.webp",
    link: "arthroscopy-sports-injury-treatment",
    title: "Arthroscopy Meerut",
  },
  {
    name: "Fracture Management",
    image: "/images/specialties/Fracture Management.webp", 
    alt: "Fracture Management",
    icon: "knee.webp",
    link: "fracture-management",
    title: "Advanced Fracture Treatment",
  },
  {
    name: "Knee Replacement",
    image: "/images/specialties/Knee Replacement Surgery.webp",
    alt: "Knee Replacement",
    icon: "knee.webp",
    link: "knee-replacement-surgery",
    title: "Advanced Knee Replacement Surgery",
  },
  {
    name: "Hip Joint Replacement",
    image:  "/images/specialties/Hip Replacement Surgery.webp",
    alt: "Hip Joint Replacement",
    icon: "hip.webp",
    link: "hip-replacement-surgery",
    title: "Hip Joint Replacement Surgery",
  },
  {
    name: "Spine & Back Pain Treatment",
    image: "/images/specialties/Spine & Back Pain Treatment.webp",
    alt: "Spine & Back Pain Treatment",
    icon: "spine.webp",
    link: "spine-back-pain-treatment",
    title: "Complex Trauma & Emergency Care",
  },
  {
    name: "Sports Injury Treatment",
    image: "/images/specialties/Arthroscopy & Sports Injury Treatment.webp",
    alt: "Sports Injury Treatment",
    icon: "foot.webp",
    link: "arthroscopy-sports-injury-treatment",
    title: "Sports Injury Rehabilitation",
  },
  {
    name: "Infertility Treatment",
    image: "/images/specialties/Infertility Treatments.webp",
    alt: "Infertility Treatment",
    icon: "arthoscopy.webp",
    link: "infertility-treatments",
    title: "Comprehensive Infertility Care",
  },
  {
    name: "High-Risk Pregnancy",
    image: "/images/specialties/Normal & High-Risk Pregnancy.webp",
    alt: "High-Risk Pregnancy",
    icon: "rheumatology.webp",
    link: "normal-high-risk-pregnancy-care",
    title: "High-Risk Pregnancy Management",
  },
];

const SpecialtiesSection = () => {
  return (
    <>
      <div className="our-services bg-radius-section">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-7">
              <div className="section-title">
                <h2 className="text-anime-style-3" data-cursor="-opaque">
                  For Our Specialties
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            {localSpecialties.map((specialty, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div className="service-item wow fadeInUp" data-wow-delay={`${index * 0.15}s`}>
                  <div className="service-item-image">
                    <figure>
                      <img loading="lazy"
                        src={specialty.image || "https://placehold.co/400x200?text=Specialty+Image"}
                        alt={specialty.alt || specialty.name}
                        style={{ width: "100%", borderRadius: "8px" }}
                        width="562"
                        height="374"
                      />
                    </figure>
                  </div>
                  <div className="service-body d-flex justify-content-between align-items-center">
                    <div className="service-content">
                      <h4 style={{color: 'white'}}>{specialty.name}</h4>
                      <p>{specialty.title}</p>
                    </div>
                    <div className="service-btn">
                      <Link to={`/specialties/${specialty.link}`} title={specialty.title}>
                        <img loading="lazy" src="/images/svg-icons/arrow-readmore-btn.svg" alt="More" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="more-service-btn text-center mt-5">
            <Link to="/specialties" className="btn btn-link">
              Find Out More About Our Specialties
              <img loading="lazy" src="/images/svg-icons/arrow-long-white.svg" alt="Arrow" />
            </Link>
          </div>
        </div>

        <div className="bg-section bg-radius-section"></div>
      </div>
    </>
  );
};

export default SpecialtiesSection;
